var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{
  'btn': true,
  'btn-primary': !(_vm.saving || !_vm.hasChanged),
  'btn-link': _vm.saving || !_vm.hasChanged
},attrs:{"type":"button","disabled":_vm.saving || !_vm.hasChanged},on:{"click":_vm.click}},[(_vm.saving && _vm.clicked)?_c('span',[_vm._v(_vm._s(_vm.savingText))]):(!_vm.saving && _vm.hasChanged)?_c('span',[_vm._v(_vm._s(_vm.saveText))]):_c('span',{staticClass:"span-flex-center"},[_c('IconCheck',{staticClass:"no-primary match-icon-color mr-1",attrs:{"height":"18"}}),_c('span',[_vm._v(_vm._s(_vm.savedText))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }